import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppPaths } from 'src/enums/app-paths'

const routes: Routes = [
  {
    path: '',
    redirectTo: `/${AppPaths.Auth}`,
    pathMatch: 'full',
  },
  {
    path: AppPaths.Auth,
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: AppPaths.Identity,
    loadChildren: () => import('./identity/identity.module').then((m) => m.IdentityModule),
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
